import React from "react";

import { MessagePageLayout } from "..";

import EmptyListImage from "../../../../assets/images/mercurio_error_vacio.svg";

export const EmptyFilterSearch = () => {
  return (
    <MessagePageLayout
      imageProps={{ src: EmptyListImage }}
      title="No encontramos resultados"
      text="Te sugerimos revisar el filtro aplicado, o intentar con otra búsqueda"
    />
  );
};
